import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";

import { MarketingFaqPage } from "../components/marketing/MarketingFaqPage";

export const Route = createFileRoute("/faq")({
  head: () => marketingHead("/faq"),
  component: MarketingFaqPage,
});
